import { openBlock as t, createElementBlock as a, createElementVNode as e } from "vue";
const h = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, o = /* @__PURE__ */ e("g", { "clip-path": "url(#a)" }, [
  /* @__PURE__ */ e("path", {
    "fill-rule": "evenodd",
    d: "M5.838 1.295a.7.7 0 0 1 .7-.7h13.464a.7.7 0 0 1 .382.113l2.954 1.924a.7.7 0 0 1 0 1.174l-2.954 1.923a.7.7 0 0 1-.382.113h-5.161v2.715h2.872a.7.7 0 0 1 .7.7v3.847a.7.7 0 0 1-.7.7h-2.872v9.491a.7.7 0 0 1-.7.7h-3.847a.7.7 0 0 1-.7-.7v-9.491H4.249a.7.7 0 0 1-.382-.114L.913 11.766a.7.7 0 0 1 0-1.173L3.867 8.67a.7.7 0 0 1 .382-.113h5.345V5.842H6.538a.7.7 0 0 1-.7-.7V1.295Zm5.156 7.262h2.447V5.842h-2.447v2.715Zm0 5.247v8.791h2.447v-8.791h-2.447ZM7.238 1.994v2.448h12.556l1.88-1.223-1.88-1.224H7.238Zm-4.66 9.186 1.879-1.223h12.556v2.447H4.457l-1.88-1.224Z",
    "clip-rule": "evenodd"
  })
], -1), l = /* @__PURE__ */ e("defs", null, [
  /* @__PURE__ */ e("clipPath", { id: "a" }, [
    /* @__PURE__ */ e("path", { d: "M0 0h24v24H0z" })
  ])
], -1), n = [
  o,
  l
];
function c(d, s) {
  return t(), a("svg", h, [...n]);
}
const v = { render: c };
export {
  v as default,
  c as render
};
